import { Pipe, PipeTransform, inject } from '@angular/core';
import { LDFlagSet } from 'launchdarkly-js-client-sdk';
import { distinctUntilChanged, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FeatureFlagsService } from '../feature-flags.service';

@Pipe({
  name: 'featureFlagNumber',
  standalone: false,
})
export class FeatureFlagNumberPipe implements PipeTransform {
  private readonly featureFlagsService = inject(FeatureFlagsService);

  transform(value: string): Observable<number> {
    return this.featureFlagsService.flag$.pipe(
      map((flags: LDFlagSet) => flags[value]),
      distinctUntilChanged(),
    );
  }
}
